;(function () {
  'use strict'

  angular.module('contrast.avatar').factory('avatarFactory', avatarFactory)

  function avatarFactory(
    atob,
    md5,
    FormData,
    Uint8Array,
    Blob,
    FileReader,
    $http,
    $rootScope,
    $q,
    ProfileService,
    GLOBAL_EVENTS
  ) {
    'ngInject'

    return {
      getAvatarUrl: getAvatarUrl,
      getGravatarUrl: getGravatarUrl,
      uploadUserAvatar: uploadUserAvatar
    }

    function getUserAvatarUrl(username) {
      var url = '/Contrast/api/ng/user/avatar'
      if (username && ProfileService.getUid != username) {
        url += '?uid=' + username
      }
      return url
    }

    function getGravatarUrl(username, size) {
      var queryString = '?d=404'

      if (!angular.isUndefined(size)) {
        queryString += '&s=' + size
      } else {
        queryString += '&s=190'
      }

      return (
        'https://www.gravatar.com/avatar/' +
        md5(username.trim().toLowerCase()) +
        queryString
      )
    }

    function getAvatarUrl(username, size) {
      var defaultUrl = getUserAvatarUrl(),
        defaultUserUrl = getUserAvatarUrl(username)

      return $http
        .get('/Contrast/api/ng/user/avatar/url', {
          params: {
            uid: username
          }
        })
        .then(function (response) {
          var url = response.data

          if (url == defaultUrl) {
            return $http
              .get(defaultUserUrl, { responseType: 'blob' })
              .then(function (response) {
                return blobToBase64(response.data).then(function (base64Data) {
                  return {
                    avatar: base64Data
                  }
                })
              })
          } else if (url != '') {
            return {
              url: url
            }
          }
          return getGravatar(username, size)
        })
        .catch(getGravatar(username, size))
    }

    function getGravatar(username, size) {
      return function () {
        var gravatarUrl = getGravatarUrl(username, size)

        return $http
          .get(gravatarUrl)
          .then(function () {
            return {
              url: gravatarUrl,
              gravatar: true
            }
          })
          .catch(function () {
            return {
              url: null
            }
          })
      }
    }

    function uploadUserAvatar(image) {
      if (image.indexOf('images/cats/') > -1) {
        return setDefaultAvatar(image.slice('images/cats/'.length))
      } else {
        var base64ImageContent = image.replace(
            /^data:image\/(png|jpg);base64,/,
            ''
          ),
          blob = base64ToBlob(base64ImageContent, 'image/png'),
          formData = new FormData()

        formData.append('avatar', blob)

        return $http
          .post('/Contrast/api/ng/user/avatar/upload', formData, {
            transformRequest: angular.identity,
            headers: {
              'Content-Type': undefined
            }
          })
          .then(function () {
            $rootScope.$broadcast(GLOBAL_EVENTS.AVATAR_UPDATE)
          })
      }
    }

    function setDefaultAvatar(filename) {
      return $http
        .post('/Contrast/api/ng/user/avatar/default', {
          default_avatar: filename
        })
        .then(function () {
          $rootScope.$broadcast(GLOBAL_EVENTS.AVATAR_UPDATE)
        })
    }

    function base64ToBlob(base64, mime) {
      mime = mime || ''
      var byteChars = atob(base64)

      return byteCharsToBlob(byteChars, mime)
    }

    function byteCharsToBlob(byteChars, mime) {
      var sliceSize = 1024
      var byteArrays = []

      for (
        var offset = 0, len = byteChars.length;
        offset < len;
        offset += sliceSize
      ) {
        var slice = byteChars.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      return new Blob(byteArrays, { type: mime })
    }

    function blobToBase64(blob) {
      var deferred = $q.defer(),
        reader = new FileReader()

      reader.onloadend = function () {
        deferred.resolve(reader.result)
      }
      reader.readAsDataURL(blob)

      return deferred.promise
    }
  }
})()
